import React from "react";
import bannBT from "../../images/_Trazado_.png";
import Computer from "../../images/phone-computer.png";
import lockImg from "../../images/lock.png";
import networkImg from "../../images/phone-network.png";
import { useLanguage } from "../../Providers/LanguageContext";
import bgImg from '../../images/image (8).png'
import smallimg from '../../images/responsive 1.png'
import smallimg2 from '../../images/cyber-security 1.png'
import smallimg3 from '../../images/mobile-management 1.png'
import img from '../../images/image (9).png'
import img2 from '../../images/Group 1171275190.png'
import img3 from '../../images/image (10).png'
import smallimg4 from '../../images/image (33).png'
import smallimg5 from '../../images/image (34).png'
function Bannerbottom() {
  const { language, currentLanguage, } = useLanguage();
  const points = [
    {
      image: Computer,
      description: language.take_control_point_1,
    },
    {
      image: lockImg,
      description: language.take_control_point_2,
    },
    {
      image: networkImg,
      description: language.take_control_point_3,
    },
  ];
  return (
    <>
      <section className="d-none"
        id="banner_bottom"
        style={{ backgroundImage: `url('${bannBT}')` }}
      >
        <div className="container">
          <div className="main_cnt">
            {points.map((item, i) => {
              return (
                <div className="box_card" key={i}>
                  <div className="icon_area">
                    <img src={item.image} className="img-fluid" alt="icon" />
                  </div>
                  <div className="description">
                    <p>{item.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>


      <div className="financial_visibility_wrapper">
        <div className="visibility_content_Wrapper container-fluid">
          <div className="financial_visibility_left">
            {currentLanguage == 'eng' ? <h1>Access Financial Visibility For Your Personal Use & Business </h1> : <h1>Acceda a La Visibilidad Financiera Para Su Uso Personal y Empresarial</h1>}
            <h6>{language.take_control}</h6>


            <div className="financial_visibility_points_wrapper">
              {points.map((e, i) => {
                return (
                  <>
                    <div key={i} className="financial_visibility_point">
                      <img src={i === 0 ? smallimg : i === 1 ? smallimg2 : i === 2 ? smallimg3 : ''} />
                      <p>{e.description}</p>
                    </div>
                  </>
                )
              })}



            </div>
          </div>
          <div className="financial_visibiliyt_right">
            <div className="financial_right_img">
              <img src={img} />
            </div>


            <div className="financial_right_img">
              <div className="d-flex justify-content-start align-items-center" style={{
                padding: '0px 5px',
                columnGap: '10px'
              }}>
                <div className="img_oval_shape1">
                  <img src={smallimg4} />
                </div>
                <div className="img_oval_shape2">
                  <img src={smallimg5} />
                </div>
              </div>

              <div className="financial_right_img_div_content">
                <h5>Affordable Financial Management</h5>

                <h6>Current Financial Performance
                  Budget Management</h6>
              </div>

            </div>

            <div className="financial_right_img">
              <img src={img3} />
            </div>





          </div>
        </div>

      </div>

    </>
  );
}

export default Bannerbottom;
